export default class DateTimeFormatter {
    static format(t, undefValue = undefined) {
        if (!t && undefValue) return undefValue
        if (t && t.length > 10)
            return t.substring(0, 19)
        return t
    }
}